// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  min-height: 100vh;
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes slideRight {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-100vh) rotate(180deg);
    opacity: 0;
  }
}
@keyframes pulse-glow {
  0%,
  100% {
    opacity: 0.4;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.1);
  }
}
@keyframes shimmer {
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
}
@keyframes spin-ring {
  to {
    transform: rotate(360deg);
  }
}
@keyframes crown-bounce {
  0%,
  100% {
    transform: translateY(0) rotate(-5deg);
  }
  50% {
    transform: translateY(-6px) rotate(5deg);
  }
}
@keyframes star-pop {
  0% {
    transform: scale(0) rotate(-30deg);
  }
  60% {
    transform: scale(1.3) rotate(10deg);
  }
  100% {
    transform: scale(1) rotate(0);
  }
}
.anim-slide-up {
  opacity: 0;
  animation: slideUp 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}
.anim-slide-right {
  opacity: 0;
  animation: slideRight 0.4s ease-out forwards;
}
.anim-fade-in {
  opacity: 0;
  animation: fadeIn 0.5s ease-out forwards;
}
.lb {
  background: #0f0e17;
  padding: 24px;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}
.lb__particles {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}
.particle {
  position: absolute;
  bottom: -20px;
  width: 6px;
  height: 6px;
  background: #7f5af0;
  border-radius: 50%;
  opacity: 0;
  animation: float 8s linear infinite;
  box-shadow: 0 0 6px rgba(127, 90, 240, 0.4);
}
.particle:nth-child(odd) {
  background: #f1c40f;
  box-shadow: 0 0 6px rgba(241, 196, 15, 0.4);
  width: 4px;
  height: 4px;
}
.particle:nth-child(3n) {
  background: #2cb67d;
  box-shadow: 0 0 6px rgba(44, 182, 125, 0.4);
  width: 5px;
  height: 5px;
}
.lb__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  position: relative;
  z-index: 1;
}
.lb__title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.lb__title h2 {
  margin: 0;
  font-size: 26px;
  font-weight: 800;
  color: #fffffe;
  letter-spacing: -0.5px;
  background: linear-gradient(135deg, #fffffe 0%, #7f5af0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.lb__trophy {
  font-size: 32px;
  animation: crown-bounce 2s ease-in-out infinite;
}
.lb__subtitle {
  font-size: 12px;
  color: #a7a9be;
  background: rgba(127, 90, 240, 0.15);
  padding: 3px 10px;
  border-radius: 20px;
  border: 1px solid rgba(127, 90, 240, 0.3);
}
.lb__select {
  background: #1a1a2e;
  color: #fffffe;
  border: 1px solid rgba(127, 90, 240, 0.3);
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.lb__select:hover,
.lb__select:focus {
  border-color: #7f5af0;
  box-shadow: 0 0 12px rgba(127, 90, 240, 0.4);
  outline: none;
}
.lb__loading {
  text-align: center;
  padding: 80px 20px;
  color: #a7a9be;
}
.lb__loading p {
  margin-top: 16px;
}
.lb__loading-ring {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(127, 90, 240, 0.2);
  border-top-color: #7f5af0;
  border-radius: 50%;
  animation: spin-ring 0.8s linear infinite;
  margin: 0 auto;
}
.lb__error {
  text-align: center;
  padding: 60px 20px;
  color: #e53170;
}
.lb__error i {
  font-size: 32px;
}
.lb__error p {
  margin: 12px 0;
  color: #a7a9be;
}
.lb__error button {
  padding: 8px 20px;
  background: transparent;
  border: 1px solid #e53170;
  color: #e53170;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}
.lb__error button:hover {
  background: rgba(229, 49, 112, 0.1);
}
.lb__empty {
  text-align: center;
  padding: 80px 20px;
  color: #a7a9be;
}
.lb__empty span {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
}
.podium {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 20px;
  margin-bottom: 40px;
  padding: 30px 20px 0;
  position: relative;
  z-index: 1;
}
.podium__spot {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 200px;
  position: relative;
}
.podium__glow {
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: var(--glow-color);
  filter: blur(40px);
  opacity: 0.3;
  animation: pulse-glow 3s ease-in-out infinite;
}
.podium__glow--gold {
  width: 160px;
  height: 160px;
  opacity: 0.4;
}
.podium__crown {
  font-size: 28px;
  animation: crown-bounce 2s ease-in-out infinite;
  margin-bottom: 4px;
}
.podium__medal {
  font-size: 28px;
  margin-bottom: 8px;
}
.podium__avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 3px solid var(--ring-color);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1a1a2e;
  margin-bottom: 8px;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.1), inset 0 0 20px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s, box-shadow 0.3s;
}
.podium__avatar span {
  font-size: 28px;
}
.podium__avatar:hover {
  transform: scale(1.1);
  box-shadow: 0 0 30px var(--ring-color);
}
.podium__avatar--lg {
  width: 84px;
  height: 84px;
  border-width: 4px;
}
.podium__avatar--lg span {
  font-size: 36px;
}
.podium__name {
  font-weight: 600;
  font-size: 14px;
  color: #fffffe;
  text-align: center;
  margin-top: 4px;
}
.podium__name--champ {
  font-size: 16px;
  background: linear-gradient(90deg, #f1c40f, #fff, #f1c40f);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shimmer 3s linear infinite;
}
.podium__level {
  font-size: 11px;
  font-weight: 600;
  margin-top: 2px;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.podium__score {
  font-size: 22px;
  font-weight: 800;
  color: #7f5af0;
  margin-top: 6px;
  text-shadow: 0 0 10px rgba(127, 90, 240, 0.4);
}
.podium__score--big {
  font-size: 30px;
  background: linear-gradient(135deg, #7f5af0, #f1c40f);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: none;
  filter: drop-shadow(0 0 8px rgba(127, 90, 240, 0.4));
}
.podium__stars {
  display: flex;
  gap: 2px;
  margin-top: 6px;
}
.star {
  font-size: 18px;
  color: rgba(167, 169, 190, 0.3);
  transition: all 0.3s;
}
.star--lit {
  color: #f1c40f;
  text-shadow: 0 0 8px rgba(241, 196, 15, 0.6);
  animation: star-pop 0.4s ease-out backwards;
}
.star--lit:nth-child(2) {
  animation-delay: 0.1s;
}
.star--lit:nth-child(3) {
  animation-delay: 0.2s;
}
.podium__pillar {
  width: 100%;
  border-radius: 12px 12px 0 0;
  margin-top: 12px;
  position: relative;
  overflow: hidden;
}
.podium__pillar::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
}
.podium__pillar--1 {
  height: 120px;
  background: linear-gradient(180deg, rgba(241, 196, 15, 0.8) 0%, rgba(241, 196, 15, 0.2) 100%);
  box-shadow: 0 0 30px rgba(241, 196, 15, 0.3);
}
.podium__pillar--2 {
  height: 85px;
  background: linear-gradient(180deg, rgba(189, 195, 199, 0.6) 0%, rgba(189, 195, 199, 0.15) 100%);
  box-shadow: 0 0 20px rgba(189, 195, 199, 0.2);
}
.podium__pillar--3 {
  height: 60px;
  background: linear-gradient(180deg, rgba(205, 127, 50, 0.6) 0%, rgba(205, 127, 50, 0.15) 100%);
  box-shadow: 0 0 20px rgba(205, 127, 50, 0.2);
}
.hero-stats {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 40px;
  position: relative;
  z-index: 1;
}
.hero-stat {
  background: #1a1a2e;
  border: 1px solid rgba(127, 90, 240, 0.2);
  border-radius: 16px;
  padding: 20px 28px;
  text-align: center;
  min-width: 120px;
  transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s;
}
.hero-stat:hover {
  transform: translateY(-4px);
  border-color: #7f5af0;
  box-shadow: 0 8px 30px rgba(127, 90, 240, 0.4);
}
.hero-stat__icon {
  font-size: 24px;
  margin-bottom: 8px;
}
.hero-stat__value {
  font-size: 22px;
  font-weight: 800;
  color: #fffffe;
}
.hero-stat__label {
  font-size: 11px;
  color: #a7a9be;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 4px;
}
.charts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 40px;
  position: relative;
  z-index: 1;
}
.chart-card {
  background: #1a1a2e;
  border: 1px solid rgba(127, 90, 240, 0.15);
  border-radius: 16px;
  padding: 16px;
  transition: border-color 0.3s, box-shadow 0.3s;
}
.chart-card:hover {
  border-color: rgba(127, 90, 240, 0.4);
  box-shadow: 0 4px 20px rgba(127, 90, 240, 0.1);
}
.rankings {
  position: relative;
  z-index: 1;
  margin-bottom: 40px;
}
.rankings__title {
  color: #fffffe;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 16px 0;
}
.rankings__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.rank-row {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #1a1a2e;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 12px 16px;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.rank-row:hover {
  background: #22223a;
  transform: translateX(4px) scale(1.01);
  border-color: rgba(127, 90, 240, 0.3);
  box-shadow: 0 4px 20px rgba(127, 90, 240, 0.1);
}
.rank-row--gold {
  border-color: rgba(241, 196, 15, 0.3);
  background: linear-gradient(135deg, rgba(241, 196, 15, 0.05) 0%, #1a1a2e 100%);
}
.rank-row--gold:hover {
  border-color: rgba(241, 196, 15, 0.6);
  box-shadow: 0 4px 20px rgba(241, 196, 15, 0.15);
}
.rank-row--silver {
  border-color: rgba(189, 195, 199, 0.2);
  background: linear-gradient(135deg, rgba(189, 195, 199, 0.05) 0%, #1a1a2e 100%);
}
.rank-row--bronze {
  border-color: rgba(205, 127, 50, 0.2);
  background: linear-gradient(135deg, rgba(205, 127, 50, 0.05) 0%, #1a1a2e 100%);
}
.rank-row__position {
  width: 36px;
  text-align: center;
}
.rank-row__badge {
  font-size: 20px;
}
.rank-row__avatar-sm {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid var(--ring-color);
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
}
.rank-row__avatar-sm span {
  font-size: 18px;
}
.rank-row__info {
  flex: 1;
  min-width: 0;
}
.rank-row__name {
  font-weight: 600;
  font-size: 14px;
  color: #fffffe;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rank-row__level-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}
.rank-row__level-tag {
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  padding: 1px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.rank-row__xp-bar {
  flex: 1;
  height: 4px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 2px;
  overflow: hidden;
  max-width: 100px;
}
.rank-row__xp-fill {
  height: 100%;
  border-radius: 2px;
  transition: width 1s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 0 6px currentColor;
}
.rank-row__stats {
  display: flex;
  gap: 16px;
  align-items: center;
}
.rank-row__stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 50px;
}
.rank-row__stat-val {
  font-size: 14px;
  font-weight: 700;
  color: #fffffe;
  font-variant-numeric: tabular-nums;
}
.rank-row__stat-val--warn {
  color: #e53170;
  text-shadow: 0 0 6px rgba(229, 49, 112, 0.4);
}
.rank-row__stat-val--fire {
  color: #ff8906;
}
.rank-row__stat-lbl {
  font-size: 9px;
  color: #a7a9be;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.quality-val--good {
  color: #2cb67d;
  text-shadow: 0 0 6px rgba(44, 182, 125, 0.4);
}
.quality-val--ok {
  color: #ff8906;
}
.quality-val--bad {
  color: #e53170;
  text-shadow: 0 0 6px rgba(229, 49, 112, 0.4);
}
.scoring {
  background: #1a1a2e;
  border: 1px solid rgba(127, 90, 240, 0.15);
  border-radius: 16px;
  padding: 20px;
  position: relative;
  z-index: 1;
}
.scoring__title {
  margin: 0 0 14px 0;
  font-size: 14px;
  font-weight: 700;
  color: #fffffe;
}
.scoring__grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}
.scoring__item {
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 6px;
  font-weight: 600;
}
.scoring__item--plus {
  background: rgba(44, 182, 125, 0.15);
  color: #2cb67d;
  border: 1px solid rgba(44, 182, 125, 0.3);
}
.scoring__item--minus {
  background: rgba(229, 49, 112, 0.15);
  color: #e53170;
  border: 1px solid rgba(229, 49, 112, 0.3);
}
.scoring__item--mult {
  background: rgba(127, 90, 240, 0.15);
  color: #7f5af0;
  border: 1px solid rgba(127, 90, 240, 0.3);
}
.scoring__levels {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.scoring__level-chip {
  padding: 3px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background: var(--chip-color);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s, box-shadow 0.2s;
}
.scoring__level-chip:hover {
  transform: scale(1.08);
  box-shadow: 0 0 12px var(--chip-color);
}
`, "",{"version":3,"sources":["webpack://./src/app/leaderboard-module/leaderboard/leaderboard.component.less"],"names":[],"mappings":"AAkBA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AAjBF;AAqBA;EACE;IAAO,UAAA;IAAY,uCAAA;EAjBnB;EAkBA;IAAK,UAAA;IAAY,iCAAA;EAdjB;AACF;AAgBA;EACE;IAAO,UAAA;IAAY,4BAAA;EAZnB;EAaA;IAAK,UAAA;IAAY,wBAAA;EATjB;AACF;AAWA;EACE;IAAO,UAAA;IAAY,2BAAA;EAPnB;EAQA;IAAK,UAAA;IAAY,wBAAA;EAJjB;AACF;AAMA;EACE;;IAAW,qCAAA;IAAuC,YAAA;EADlD;EAEA;IAAM,4CAAA;IAA8C,UAAA;EAEpD;AACF;AAAA;EACE;;IAAW,YAAA;IAAc,mBAAA;EAKzB;EAJA;IAAM,YAAA;IAAc,qBAAA;EAQpB;AACF;AANA;EACE;IAAK,iCAAA;EASL;EARA;IAAO,gCAAA;EAWP;AACF;AATA;EACE;IAAK,yBAAA;EAYL;AACF;AAVA;EACE;;IAAW,sCAAA;EAcX;EAbA;IAAM,wCAAA;EAgBN;AACF;AAdA;EACE;IAAK,kCAAA;EAiBL;EAhBA;IAAM,mCAAA;EAmBN;EAlBA;IAAO,6BAAA;EAqBP;AACF;AAnBA;EACE,UAAA;EACA,kEAAA;AAqBF;AAlBA;EACE,UAAA;EACA,4CAAA;AAoBF;AAjBA;EACE,UAAA;EACA,wCAAA;AAmBF;AAfA;EACE,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAiBF;AAbA;EACE,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,gBAAA;AAeF;AAZA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,mCAAA;EACA,2CAAA;AAcF;AAZE;EAAmB,mBAAA;EAAmB,2CAAA;EAAsC,UAAA;EAAY,WAAA;AAkB1F;AAjBE;EAAkB,mBAAA;EAAoB,2CAAA;EAAuC,UAAA;EAAY,WAAA;AAuB3F;AAnBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAqBF;AAlBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAoBF;AAvBA;EAMI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,6DAAA;EACA,6BAAA;EACA,oCAAA;AAoBJ;AAhBA;EACE,eAAA;EACA,+CAAA;AAkBF;AAfA;EACE,eAAA;EACA,cAAA;EACA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;AAiBF;AAdA;EACE,mBAAA;EACA,cAAA;EACA,yCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,8CAAA;AAgBF;AAdE;;EACE,qBAAA;EACA,4CAAA;EACA,aAAA;AAiBJ;AAZA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AAcF;AAjBA;EAKM,gBAAA;AAeN;AAZA;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,cAAA;AAcF;AAXA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AAaF;AAhBA;EAKM,eAAA;AAcN;AAnBA;EAMM,cAAA;EAAgB,cAAA;AAiBtB;AAvBA;EASI,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AAiBJ;AAhBI;EAAU,mCAAA;AAmBd;AAfA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AAiBF;AApBA;EAIS,eAAA;EAAiB,cAAA;EAAgB,mBAAA;AAqB1C;AAjBA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;AAmBF;AAhBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAkBF;AAfA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,6CAAA;AAiBF;AAdA;EACE,YAAA;EACA,aAAA;EACA,YAAA;AAgBF;AAbA;EACE,eAAA;EACA,+CAAA;EACA,kBAAA;AAeF;AAZA;EACE,eAAA;EACA,kBAAA;AAcF;AAXA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gFAAA;EACA,2CAAA;AAaF;AAxBA;EAaS,eAAA;AAcT;AAZE;EACE,qBAAA;EACA,sCAAA;AAcJ;AAVA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAYF;AAfA;EAIS,eAAA;AAcT;AAXA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAaF;AAVA;EACE,eAAA;EACA,0DAAA;EACA,0BAAA;EACA,6BAAA;EACA,oCAAA;EACA,qCAAA;AAYF;AATA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AAWF;AARA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,6CAAA;AAUF;AAPA;EACE,eAAA;EACA,qDAAA;EACA,6BAAA;EACA,oCAAA;EACA,iBAAA;EACA,oDAAA;AASF;AANA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAQF;AALA;EACE,eAAA;EACA,+BAAA;EACA,oBAAA;AAOF;AAJA;EACE,cAAA;EACA,4CAAA;EACA,2CAAA;AAMF;AAJE;EAAiB,qBAAA;AAOnB;AANE;EAAiB,qBAAA;AASnB;AANA;EACE,WAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAQF;AANE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,iFAAA;AAQJ;AAJA;EACE,aAAA;EACA,6FAAA;EACA,4CAAA;AAMF;AAHA;EACE,YAAA;EACA,gGAAA;EACA,6CAAA;AAKF;AAFA;EACE,YAAA;EACA,8FAAA;EACA,4CAAA;AAIF;AAAA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAEF;AACA;EACE,mBAAA;EACA,yCAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8DAAA;AACF;AACE;EACE,2BAAA;EACA,qBAAA;EACA,8CAAA;AACJ;AAGA;EACE,eAAA;EACA,kBAAA;AADF;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;AAKA;EACE,eAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;AAHF;AAOA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AALF;AAQA;EACE,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,8CAAA;AANF;AAQE;EACE,qCAAA;EACA,8CAAA;AANJ;AAWA;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;AATF;AAYA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAVF;AAaA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAXF;AAcA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,sDAAA;AAZF;AAcE;EACE,mBAAA;EACA,sCAAA;EACA,qCAAA;EACA,8CAAA;AAZJ;AAgBA;EACE,qCAAA;EACA,8EAAA;AAdF;AAeE;EAAU,qCAAA;EAAgC,+CAAA;AAX5C;AAcA;EACE,sCAAA;EACA,+EAAA;AAZF;AAeA;EACE,qCAAA;EACA,8EAAA;AAbF;AAgBA;EACE,WAAA;EACA,kBAAA;AAdF;AAiBA;EACE,eAAA;AAfF;AAkBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;AAhBF;AAOA;EAWS,eAAA;AAfT;AAkBA;EACE,OAAA;EACA,YAAA;AAhBF;AAmBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjBF;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAlBF;AAqBA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AAnBF;AAsBA;EACE,OAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AApBF;AAuBA;EACE,YAAA;EACA,kBAAA;EACA,sDAAA;EACA,gCAAA;AArBF;AAwBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAtBF;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAvBF;AA0BA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AAxBF;AA2BA;EACE,cAAA;EACA,4CAAA;AAzBF;AA4BA;EACE,cAAA;AA1BF;AA6BA;EACE,cAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AA3BF;AA8BA;EAAqB,cAAA;EAAe,4CAAA;AA1BpC;AA2BA;EAAmB,cAAA;AAxBnB;AAyBA;EAAoB,cAAA;EAAa,4CAAA;AArBjC;AAwBA;EACE,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AAtBF;AAyBA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAvBF;AA0BA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAxBF;AA2BA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAzBF;AA2BE;EAAU,oCAAA;EAA+B,cAAA;EAAe,yCAAA;AAtB1D;AAuBE;EAAW,oCAAA;EAA6B,cAAA;EAAa,yCAAA;AAlBvD;AAmBE;EAAU,oCAAA;EAAgC,cAAA;EAAgB,yCAAA;AAd5D;AAiBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAfF;AAkBA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,6BAAA;EACA,sCAAA;EACA,2CAAA;AAhBF;AAkBE;EACE,sBAAA;EACA,sCAAA;AAhBJ","sourcesContent":["// ═══════════════════════════════════════════════════════\n// LEADERBOARD — Arcade / Candy Crush aesthetic\n// ═══════════════════════════════════════════════════════\n\n@bg-dark: #0f0e17;\n@bg-card: #1a1a2e;\n@bg-card-hover: #22223a;\n@text-primary: #fffffe;\n@text-muted: #a7a9be;\n@accent: #7f5af0;\n@accent-glow: rgba(127, 90, 240, 0.4);\n@gold: #f1c40f;\n@silver: #bdc3c7;\n@bronze: #cd7f32;\n@green: #2cb67d;\n@red: #e53170;\n@orange: #ff8906;\n\n:host {\n  display: block;\n  width: 100%;\n  min-height: 100vh;\n}\n\n// ── ANIMATIONS ──\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(40px) scale(0.95); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes slideRight {\n  from { opacity: 0; transform: translateX(-30px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0) rotate(0deg); opacity: 0.6; }\n  50% { transform: translateY(-100vh) rotate(180deg); opacity: 0; }\n}\n\n@keyframes pulse-glow {\n  0%, 100% { opacity: 0.4; transform: scale(1); }\n  50% { opacity: 0.8; transform: scale(1.1); }\n}\n\n@keyframes shimmer {\n  0% { background-position: -200% center; }\n  100% { background-position: 200% center; }\n}\n\n@keyframes spin-ring {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes crown-bounce {\n  0%, 100% { transform: translateY(0) rotate(-5deg); }\n  50% { transform: translateY(-6px) rotate(5deg); }\n}\n\n@keyframes star-pop {\n  0% { transform: scale(0) rotate(-30deg); }\n  60% { transform: scale(1.3) rotate(10deg); }\n  100% { transform: scale(1) rotate(0); }\n}\n\n.anim-slide-up {\n  opacity: 0;\n  animation: slideUp 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\n}\n\n.anim-slide-right {\n  opacity: 0;\n  animation: slideRight 0.4s ease-out forwards;\n}\n\n.anim-fade-in {\n  opacity: 0;\n  animation: fadeIn 0.5s ease-out forwards;\n}\n\n// ── CONTAINER ──\n.lb {\n  background: @bg-dark;\n  padding: 24px;\n  min-height: 100vh;\n  position: relative;\n  overflow: hidden;\n}\n\n// ── PARTICLES ──\n.lb__particles {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.particle {\n  position: absolute;\n  bottom: -20px;\n  width: 6px;\n  height: 6px;\n  background: @accent;\n  border-radius: 50%;\n  opacity: 0;\n  animation: float 8s linear infinite;\n  box-shadow: 0 0 6px @accent-glow;\n\n  &:nth-child(odd) { background: @gold; box-shadow: 0 0 6px fade(@gold, 40%); width: 4px; height: 4px; }\n  &:nth-child(3n) { background: @green; box-shadow: 0 0 6px fade(@green, 40%); width: 5px; height: 5px; }\n}\n\n// ── HEADER ──\n.lb__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  position: relative;\n  z-index: 1;\n}\n\n.lb__title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  h2 {\n    margin: 0;\n    font-size: 26px;\n    font-weight: 800;\n    color: @text-primary;\n    letter-spacing: -0.5px;\n    background: linear-gradient(135deg, @text-primary 0%, @accent 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n}\n\n.lb__trophy {\n  font-size: 32px;\n  animation: crown-bounce 2s ease-in-out infinite;\n}\n\n.lb__subtitle {\n  font-size: 12px;\n  color: @text-muted;\n  background: fade(@accent, 15%);\n  padding: 3px 10px;\n  border-radius: 20px;\n  border: 1px solid fade(@accent, 30%);\n}\n\n.lb__select {\n  background: @bg-card;\n  color: @text-primary;\n  border: 1px solid fade(@accent, 30%);\n  padding: 8px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: border-color 0.2s, box-shadow 0.2s;\n\n  &:hover, &:focus {\n    border-color: @accent;\n    box-shadow: 0 0 12px @accent-glow;\n    outline: none;\n  }\n}\n\n// ── LOADING ──\n.lb__loading {\n  text-align: center;\n  padding: 80px 20px;\n  color: @text-muted;\n\n  p { margin-top: 16px; }\n}\n\n.lb__loading-ring {\n  width: 40px;\n  height: 40px;\n  border: 3px solid fade(@accent, 20%);\n  border-top-color: @accent;\n  border-radius: 50%;\n  animation: spin-ring 0.8s linear infinite;\n  margin: 0 auto;\n}\n\n.lb__error {\n  text-align: center;\n  padding: 60px 20px;\n  color: @red;\n\n  i { font-size: 32px; }\n  p { margin: 12px 0; color: @text-muted; }\n\n  button {\n    padding: 8px 20px;\n    background: transparent;\n    border: 1px solid @red;\n    color: @red;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.2s;\n    &:hover { background: fade(@red, 10%); }\n  }\n}\n\n.lb__empty {\n  text-align: center;\n  padding: 80px 20px;\n  color: @text-muted;\n  span { font-size: 48px; display: block; margin-bottom: 12px; }\n}\n\n// ═══ PODIUM ═══\n.podium {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 20px;\n  margin-bottom: 40px;\n  padding: 30px 20px 0;\n  position: relative;\n  z-index: 1;\n}\n\n.podium__spot {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 200px;\n  position: relative;\n}\n\n.podium__glow {\n  position: absolute;\n  top: 20%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background: var(--glow-color);\n  filter: blur(40px);\n  opacity: 0.3;\n  animation: pulse-glow 3s ease-in-out infinite;\n}\n\n.podium__glow--gold {\n  width: 160px;\n  height: 160px;\n  opacity: 0.4;\n}\n\n.podium__crown {\n  font-size: 28px;\n  animation: crown-bounce 2s ease-in-out infinite;\n  margin-bottom: 4px;\n}\n\n.podium__medal {\n  font-size: 28px;\n  margin-bottom: 8px;\n}\n\n.podium__avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  border: 3px solid var(--ring-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: @bg-card;\n  margin-bottom: 8px;\n  box-shadow: 0 0 20px fade(#fff, 10%), inset 0 0 20px fade(#000, 30%);\n  transition: transform 0.3s, box-shadow 0.3s;\n\n  span { font-size: 28px; }\n\n  &:hover {\n    transform: scale(1.1);\n    box-shadow: 0 0 30px var(--ring-color);\n  }\n}\n\n.podium__avatar--lg {\n  width: 84px;\n  height: 84px;\n  border-width: 4px;\n  span { font-size: 36px; }\n}\n\n.podium__name {\n  font-weight: 600;\n  font-size: 14px;\n  color: @text-primary;\n  text-align: center;\n  margin-top: 4px;\n}\n\n.podium__name--champ {\n  font-size: 16px;\n  background: linear-gradient(90deg, @gold, #fff, @gold);\n  background-size: 200% auto;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  animation: shimmer 3s linear infinite;\n}\n\n.podium__level {\n  font-size: 11px;\n  font-weight: 600;\n  margin-top: 2px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.podium__score {\n  font-size: 22px;\n  font-weight: 800;\n  color: @accent;\n  margin-top: 6px;\n  text-shadow: 0 0 10px @accent-glow;\n}\n\n.podium__score--big {\n  font-size: 30px;\n  background: linear-gradient(135deg, @accent, @gold);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  text-shadow: none;\n  filter: drop-shadow(0 0 8px @accent-glow);\n}\n\n.podium__stars {\n  display: flex;\n  gap: 2px;\n  margin-top: 6px;\n}\n\n.star {\n  font-size: 18px;\n  color: fade(@text-muted, 30%);\n  transition: all 0.3s;\n}\n\n.star--lit {\n  color: @gold;\n  text-shadow: 0 0 8px fade(@gold, 60%);\n  animation: star-pop 0.4s ease-out backwards;\n\n  &:nth-child(2) { animation-delay: 0.1s; }\n  &:nth-child(3) { animation-delay: 0.2s; }\n}\n\n.podium__pillar {\n  width: 100%;\n  border-radius: 12px 12px 0 0;\n  margin-top: 12px;\n  position: relative;\n  overflow: hidden;\n\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(180deg, fade(#fff, 10%) 0%, transparent 50%);\n  }\n}\n\n.podium__pillar--1 {\n  height: 120px;\n  background: linear-gradient(180deg, fade(@gold, 80%) 0%, fade(@gold, 20%) 100%);\n  box-shadow: 0 0 30px fade(@gold, 30%);\n}\n\n.podium__pillar--2 {\n  height: 85px;\n  background: linear-gradient(180deg, fade(@silver, 60%) 0%, fade(@silver, 15%) 100%);\n  box-shadow: 0 0 20px fade(@silver, 20%);\n}\n\n.podium__pillar--3 {\n  height: 60px;\n  background: linear-gradient(180deg, fade(@bronze, 60%) 0%, fade(@bronze, 15%) 100%);\n  box-shadow: 0 0 20px fade(@bronze, 20%);\n}\n\n// ═══ HERO STATS ═══\n.hero-stats {\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  margin-bottom: 40px;\n  position: relative;\n  z-index: 1;\n}\n\n.hero-stat {\n  background: @bg-card;\n  border: 1px solid fade(@accent, 20%);\n  border-radius: 16px;\n  padding: 20px 28px;\n  text-align: center;\n  min-width: 120px;\n  transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s;\n\n  &:hover {\n    transform: translateY(-4px);\n    border-color: @accent;\n    box-shadow: 0 8px 30px @accent-glow;\n  }\n}\n\n.hero-stat__icon {\n  font-size: 24px;\n  margin-bottom: 8px;\n}\n\n.hero-stat__value {\n  font-size: 22px;\n  font-weight: 800;\n  color: @text-primary;\n}\n\n.hero-stat__label {\n  font-size: 11px;\n  color: @text-muted;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-top: 4px;\n}\n\n// ═══ CHARTS ═══\n.charts {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 40px;\n  position: relative;\n  z-index: 1;\n}\n\n.chart-card {\n  background: @bg-card;\n  border: 1px solid fade(@accent, 15%);\n  border-radius: 16px;\n  padding: 16px;\n  transition: border-color 0.3s, box-shadow 0.3s;\n\n  &:hover {\n    border-color: fade(@accent, 40%);\n    box-shadow: 0 4px 20px fade(@accent, 10%);\n  }\n}\n\n// ═══ RANKINGS ═══\n.rankings {\n  position: relative;\n  z-index: 1;\n  margin-bottom: 40px;\n}\n\n.rankings__title {\n  color: @text-primary;\n  font-size: 18px;\n  font-weight: 700;\n  margin: 0 0 16px 0;\n}\n\n.rankings__list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.rank-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: @bg-card;\n  border: 1px solid fade(#fff, 5%);\n  border-radius: 12px;\n  padding: 12px 16px;\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n\n  &:hover {\n    background: @bg-card-hover;\n    transform: translateX(4px) scale(1.01);\n    border-color: fade(@accent, 30%);\n    box-shadow: 0 4px 20px fade(@accent, 10%);\n  }\n}\n\n.rank-row--gold {\n  border-color: fade(@gold, 30%);\n  background: linear-gradient(135deg, fade(@gold, 5%) 0%, @bg-card 100%);\n  &:hover { border-color: fade(@gold, 60%); box-shadow: 0 4px 20px fade(@gold, 15%); }\n}\n\n.rank-row--silver {\n  border-color: fade(@silver, 20%);\n  background: linear-gradient(135deg, fade(@silver, 5%) 0%, @bg-card 100%);\n}\n\n.rank-row--bronze {\n  border-color: fade(@bronze, 20%);\n  background: linear-gradient(135deg, fade(@bronze, 5%) 0%, @bg-card 100%);\n}\n\n.rank-row__position {\n  width: 36px;\n  text-align: center;\n}\n\n.rank-row__badge {\n  font-size: 20px;\n}\n\n.rank-row__avatar-sm {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid var(--ring-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: fade(#000, 30%);\n  flex-shrink: 0;\n\n  span { font-size: 18px; }\n}\n\n.rank-row__info {\n  flex: 1;\n  min-width: 0;\n}\n\n.rank-row__name {\n  font-weight: 600;\n  font-size: 14px;\n  color: @text-primary;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rank-row__level-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.rank-row__level-tag {\n  font-size: 10px;\n  font-weight: 700;\n  color: #fff;\n  padding: 1px 8px;\n  border-radius: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n\n.rank-row__xp-bar {\n  flex: 1;\n  height: 4px;\n  background: fade(#fff, 8%);\n  border-radius: 2px;\n  overflow: hidden;\n  max-width: 100px;\n}\n\n.rank-row__xp-fill {\n  height: 100%;\n  border-radius: 2px;\n  transition: width 1s cubic-bezier(0.34, 1.56, 0.64, 1);\n  box-shadow: 0 0 6px currentColor;\n}\n\n.rank-row__stats {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.rank-row__stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 50px;\n}\n\n.rank-row__stat-val {\n  font-size: 14px;\n  font-weight: 700;\n  color: @text-primary;\n  font-variant-numeric: tabular-nums;\n}\n\n.rank-row__stat-val--warn {\n  color: @red;\n  text-shadow: 0 0 6px fade(@red, 40%);\n}\n\n.rank-row__stat-val--fire {\n  color: @orange;\n}\n\n.rank-row__stat-lbl {\n  font-size: 9px;\n  color: @text-muted;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.quality-val--good { color: @green; text-shadow: 0 0 6px fade(@green, 40%); }\n.quality-val--ok { color: @orange; }\n.quality-val--bad { color: @red; text-shadow: 0 0 6px fade(@red, 40%); }\n\n// ═══ SCORING LEGEND ═══\n.scoring {\n  background: @bg-card;\n  border: 1px solid fade(@accent, 15%);\n  border-radius: 16px;\n  padding: 20px;\n  position: relative;\n  z-index: 1;\n}\n\n.scoring__title {\n  margin: 0 0 14px 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: @text-primary;\n}\n\n.scoring__grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.scoring__item {\n  font-size: 12px;\n  padding: 4px 12px;\n  border-radius: 6px;\n  font-weight: 600;\n\n  &--plus { background: fade(@green, 15%); color: @green; border: 1px solid fade(@green, 30%); }\n  &--minus { background: fade(@red, 15%); color: @red; border: 1px solid fade(@red, 30%); }\n  &--mult { background: fade(@accent, 15%); color: @accent; border: 1px solid fade(@accent, 30%); }\n}\n\n.scoring__levels {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.scoring__level-chip {\n  padding: 3px 12px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #fff;\n  background: var(--chip-color);\n  box-shadow: 0 0 8px fade(#000, 30%);\n  transition: transform 0.2s, box-shadow 0.2s;\n\n  &:hover {\n    transform: scale(1.08);\n    box-shadow: 0 0 12px var(--chip-color);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
